export const PAGE_PARAM_KEY = 'page';
export const PAGE_SIZE_PARAM_KEY = 'size';
export const DEFAULT_PAGE = '0';
export const DEFAULT_PAGE_SIZE = '10';
export const MESSAGES_PAGE_SIZE = 20;
